export default {"src":"/_next/static/media/opportunities-readme-closed-mobile.924d20b1.svg","height":151,"width":48,"blurWidth":0,"blurHeight":0};